import React from 'react';
import { createRoot } from 'react-dom/client';
import { setErrorReporter } from '@healthshare/shared/platform/errorReporter';
import { sentryErrorReporter } from './lib/platform/sentryErrorReporter';
import 'jquery';
import 'bootstrap';
import reportWebVitals from './reportWebVitals';
import { Providers } from './app/providers';
import { ErrorBoundary } from './app/components/error-boundary';
import { Initializers } from './app/initializers';
import { Listeners } from './app/listeners';

import App from './App';
import './index.css';
import './App.scss';

// Install the web app's error reporter before rendering anything. Core code
// reports through the injected ErrorReporter rather than importing @sentry/react
// directly, so that the same modules can run under @sentry/react-native in the
// Expo app or a partner-supplied reporter in the SDK (Phase 0 of
// docs/plans/embeddable-sdk.md). Until this runs, the shared default only
// console-logs -- which is the behavior tests and Storybook get, deliberately.
setErrorReporter(sentryErrorReporter);

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  //<React.StrictMode>
    <ErrorBoundary>
      <Providers>
        <Initializers>
          <Listeners />
          <App />
        </Initializers>
      </Providers>
    </ErrorBoundary>
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
